export const EnStarredMessagesStrings = {

  ERROR_MSG: {
    IN_INIT_CHATROOM: "The chat room is initializing. Please try again later."
  }
}
